import { MakeCall } from 'ha/services/apiV2/createMakeCall';

type UniversitiesResponse = Array<{
  code: string;
  name: string;
  universities: Array<{
    id: number;
    name: string;
    slug: string;
  }>;
}>;

export default (makeCall: MakeCall) => () =>
  makeCall<UniversitiesResponse>('GET', '/sitemaps/universities.json');
